<script lang="ts" setup>
	import {computed} from 'vue';

	const props = withDefaults(
		defineProps<{
			type?: string | null;
			size?: number | string;
			showTooltip?: boolean;
			customTooltip?: string;
		}>(),
		{
			type: undefined,
			size: 16,
			showTooltip: true,
			customTooltip: undefined
		}
	);

	const normalizedType = computed(() => {
		const rawType = props.type;
		if (!rawType) return 'vegetative';
		const trimmed = rawType.trim().toLowerCase();
		if (trimmed === 'seeds' || trimmed === 'seed') return 'seeds';
		if (trimmed === 'vegetative') return 'vegetative';
		return 'vegetative';
	});

	const iconName = computed(() => {
		if (normalizedType.value === 'seeds') return 'icon-seeds';
		if (normalizedType.value === 'vegetative') return 'icon-vegetative';
		return 'icon-vegetative';
	});

	const tooltipText = computed(() => {
		if (!props.showTooltip) return undefined;
		if (props.customTooltip) return props.customTooltip;
		if (normalizedType.value === 'seeds') return 'Seeds';
		if (normalizedType.value === 'vegetative') return 'Vegetative';
		return props.type ?? 'Vegetative';
	});
</script>

<template>
	<span
		v-if="iconName"
		class="product-type-icon"
		:class="`product-type-icon--${normalizedType}`"
		:title="tooltipText"
		:aria-label="tooltipText"
	>
		<svg
			:width="size"
			:height="size"
			:class="`icon-${iconName}`"
			viewBox="0 -960 960 960"
			aria-hidden="true"
		>
			<path
				v-if="normalizedType === 'seeds'"
				d="M240-160q-33 0-56.5-23.5T160-240q0-33 23.5-56.5T240-320q33 0 56.5 23.5T320-240q0 33-23.5 56.5T240-160Zm320 0q-33 0-56.5-23.5T480-240q0-33 23.5-56.5T560-320q33 0 56.5 23.5T640-240q0 33-23.5 56.5T560-160ZM400-320q-33 0-56.5-23.5T320-400q0-33 23.5-56.5T400-480q33 0 56.5 23.5T480-400q0 33-23.5 56.5T400-320Zm320 0q-33 0-56.5-23.5T640-400q0-33 23.5-56.5T720-480q33 0 56.5 23.5T800-400q0 33-23.5 56.5T720-320ZM240-480q-33 0-56.5-23.5T160-560q0-33 23.5-56.5T240-640q33 0 56.5 23.5T320-560q0 33-23.5 56.5T240-480Zm320 0q-33 0-56.5-23.5T480-560q0-33 23.5-56.5T560-640q33 0 56.5 23.5T640-560q0 33-23.5 56.5T560-480ZM400-640q-33 0-56.5-23.5T320-720q0-33 23.5-56.5T400-800q33 0 56.5 23.5T480-720q0 33-23.5 56.5T400-640Zm320 0q-33 0-56.5-23.5T640-720q0-33 23.5-56.5T720-800q33 0 56.5 23.5T800-720q0 33-23.5 56.5T720-640Z"
			/>
			<path
				v-else-if="normalizedType === 'vegetative'"
				d="M216-176q-45-45-70.5-104T120-402q0-63 24-124.5T222-642q35-35 86.5-60t122-39.5Q501-756 591.5-759t202.5 7q8 106 5 195t-16.5 160.5q-13.5 71.5-38 125T684-182q-53 53-112.5 77.5T450-80q-65 0-127-25.5T216-176Zm112-16q29 17 59.5 24.5T450-160q46 0 91-18.5t86-59.5q18-18 36.5-50.5t32-85Q709-426 716-500.5t2-177.5q-49-2-110.5-1.5T485-670q-61 9-116 29t-90 55q-45 45-62 89t-17 85q0 59 22.5 103.5T262-246q42-80 111-153.5T534-520q-72 63-125.5 142.5T328-192Zm0 0Zm0 0Z"
			/>
		</svg>
	</span>
</template>

<style scoped>
	.product-type-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		vertical-align: -0.15em;
		margin-right: 6px;
		line-height: 1;
		flex-shrink: 0;
	}

	.product-type-icon svg {
		display: block;
		fill: currentColor;
	}
</style>
